import type { PropsWithChildren, ReactNode } from 'react';
import { Children, cloneElement, isValidElement } from 'react';

import { AccordionItem } from 'components/Accordion/Item/AccordionItem';
import { DropdownChevron } from 'components/Dropdown/Chevron/DropdownChevron';
import { Icon } from 'components/Icon/Icon';
import type { IconName } from 'components/Icon/IconName';
import type { SearchJobsRefinementType } from 'modules/search/constants/refinements/searchJobsRefinementTypes';
import type { SearchFacetVariant } from 'modules/search/types/SearchFacetVariant';

import {
  SearchFacetAccordionSummary,
  SearchFacetAccordionSummaryLabel,
} from './SearchFacetAccordionItem.styled';

type Props = {
  facetType: SearchJobsRefinementType;
  label: ReactNode;
  icon?: IconName;
};

export function SearchFacetAccordionItem({
  children,
  facetType,
  icon,
  label,
}: PropsWithChildren<Props>) {
  return (
    <AccordionItem
      name="search-facet"
      header={
        <SearchFacetAccordionSummary>
          <SearchFacetAccordionSummaryLabel>
            {icon ? <Icon size={18} name={icon} /> : undefined}
            <span>{label}</span>
          </SearchFacetAccordionSummaryLabel>
          <DropdownChevron size={16} />
        </SearchFacetAccordionSummary>
      }
    >
      <div data-facet-type={facetType}>
        {isValidElement<{ variant: SearchFacetVariant }>(children)
          ? Children.only(cloneElement(children, { variant: 'accordion' }))
          : null}
      </div>
    </AccordionItem>
  );
}
